import { render, staticRenderFns } from "./AddAutoPurchaseSetting.vue?vue&type=template&id=3eb24e1a&"
import script from "./AddAutoPurchaseSetting.vue?vue&type=script&lang=js&"
export * from "./AddAutoPurchaseSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports